module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.536fdfd9.webp";